import React from "react";
import LevelsListItem from "./LevelsListItem";
import Spinner from "components/Spinner";
import useLevels from "api/services/levels/useLevels";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, A11y } from "swiper/modules";
import { twMerge } from "tailwind-merge";
import { m } from "framer-motion";
import { gridContainerVariants } from "pages/playground/ProductGrid";
import "swiper/css";
import "swiper/css/navigation";
import LevelsList from "./LevelsList";

export const checkIfPartsAreValid = (parts) => {
  return !(
    parts != null &&
    parts?.chapter == null &&
    parts?.heading == null &&
    parts?.subheading == null
  );
};

export default function Levels({
  onSelect,
  loadingProps,
  gridLayout = false,
  ...props
}) {
  const { data: levels, isLoading, isError } = useLevels();

  if (isLoading) {
    return (
      <div
        {...loadingProps}
        className={twMerge(
          "flex flex-grow justify-center items-center",
          loadingProps?.className
        )}
      >
        <div className="flex items-center flex-col gap-4">
          <Spinner /> Səviyyələr yüklənir...
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="flex-grow flex items-center justify-center">
        <p className="text-slate-100">Xəta baş verdi</p>
      </div>
    );
  }

  if (gridLayout) {
    return (
      <LevelsList>
        {levels.map(({ attributes: level, id: levelId }) => {
          const isDisabled = !checkIfPartsAreValid(level.parts);
          const gridItemVariants = {
            hidden: { y: 20, opacity: 0 },
            visible: {
              y: 0,
              opacity: isDisabled ? 0.5 : 1,
            },
          };
          return (
            <m.li key={levelId} variants={gridItemVariants}>
              <LevelsListItem
                tabIndex={isDisabled ? -1 : 0}
                level={level}
                onKeyDown={(e) => {
                  if (
                    e.keyCode === 13 &&
                    checkIfPartsAreValid(level.parts) &&
                    typeof onSelect === "function"
                  ) {
                    onSelect(level);
                  }
                }}
                onClick={() => {
                  if (
                    checkIfPartsAreValid(level.parts) &&
                    typeof onSelect === "function"
                  ) {
                    onSelect(level);
                  }
                }}
              />
            </m.li>
          );
        })}
      </LevelsList>
    );
  }

  return (
    <Swiper
      modules={[Navigation, A11y]}
      tag={m.ul}
      initial="hidden"
      animate="visible"
      variants={gridContainerVariants}
      spaceBetween={10}
      slidesPerView={1}
      navigation
      scrollbar={{ draggable: true }}
      className="w-full h-full"
      breakpoints={{
        640: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      }}
    >
      {levels.map(({ attributes: level, id: levelId }) => {
        const isDisabled = !checkIfPartsAreValid(level.parts);
        const gridItemVariants = {
          hidden: { y: 20, opacity: 0 },
          visible: {
            y: 0,
            opacity: isDisabled ? 0.5 : 1,
          },
        };

        return (
          <SwiperSlide
            className="p-2 h-full"
            variants={gridItemVariants}
            tag={m.li}
            key={levelId}
          >
            <LevelsListItem
              tabIndex={isDisabled ? -1 : 0}
              key={levelId}
              level={level}
              onKeyDown={(e) => {
                if (
                  e.keyCode === 13 &&
                  checkIfPartsAreValid(level.parts) &&
                  typeof onSelect === "function"
                ) {
                  onSelect(level);
                }
              }}
              onClick={() => {
                if (
                  checkIfPartsAreValid(level.parts) &&
                  typeof onSelect === "function"
                ) {
                  onSelect(level);
                }
              }}
            />
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
}
